import React, { useRef } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import EventsSection from "./components/EventsSection";
// import VolunteerSection from './components/VolunteerSection';
import TeamSection from "./components/TeamSection";
import TeamPage from "./components/TeamPage";
import Footer from "./components/Footer";
import ServicesSection from "./components/ServicesSection";
import ImpactStoriesSection from "./components/ImpactStoriesSection";
// import VideoShowcaseSection from "./components/VideoShowcaseSection";
import StoryHighlightSection from "./components/StoryHighlightSection";
// import PartnersSection from "./components/PartnersSection";
import Gallery from "./components/Gallery";
import ScrollToTop from "./components/ScrollToTop";
import Storybottom from "./components/storybottom";
import ContactSection from "./components/ContactSection";
import Registration from "./components/Registration";
import HeadlineSlider from "./components/HeadlineSlider";
function App() {
  const footerRef = useRef(null);

  return (
    <Router>
      <Navbar />
      <ScrollToTop />
      <Routes>
        <Route
          path="/"
          element={
            <>
            <HeadlineSlider />
              <HeroSection />
              <ServicesSection />
              <ImpactStoriesSection />
              <StoryHighlightSection />
              {/* <VideoShowcaseSection /> */}
              {/* <PartnersSection /> */}
              <Storybottom />
              <TeamSection />
            </>
          }
        />
        <Route path="/events" element={<EventsSection />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<ContactSection />} />
          <Route path="/registration" element={<Registration />} />
        <Route path="/team" element={<TeamPage />} />
      </Routes>
      <Footer ref={footerRef} />
    </Router>
  );
}

export default App;
